var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'e-form ' + _vm.formClass},[(_vm.enablePerfectScrollbar)?_c('e-perfect-scrollbar',{attrs:{"updateStreamName":_vm.scrollUpdateStreamName,"emitTypes":['rxjs']}},[_vm._t("default")],2):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }